import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MentorSessionCancelPassData } from '@edtech-ui/core/models/mentors-sessions/mentor-cancel-pass-data';
import { MentorService } from '@edtech-ui/core/services/mentor-management/mentor.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';
import { MentorSessionCancelDialogComponent } from '../mentor-session-cancel-dialog/mentor-session-cancel-dialog.component';
import { CommonModule } from '@angular/common';
import { IstUtcDatePipe } from '@edtech-ui/core/pipes/utc-time-format.pipe';

@Component({
	selector: 'app-mentor-session-confirm-cancellation-dialog',
	standalone: true,
	imports: [MatIconModule, CommonModule, IstUtcDatePipe],
	templateUrl: './mentor-session-confirm-cancellation-dialog.component.html',
	styleUrl: './mentor-session-confirm-cancellation-dialog.component.scss'
})
export class MentorSessionConfirmCancellationDialogComponent implements OnDestroy {

	bookingId = '';
	mentorName = '';
	sessionType = '';
	sessionStartTime = '';
	sessionEndTime = '';
	isLoading = false;
	subscription = new Subscription();
	cancelReason = '';
	otherReason = '';

	constructor(
		private dialog: MatDialog,
		private dialogRef: MatDialogRef<MentorSessionConfirmCancellationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: MentorSessionCancelPassData & {
			cancelReason?: string; otherReason?: string;
		},
		private _mentorService: MentorService,
		private _toastr: ToastrService,
	) {
		this.mentorName = data.mentor_name,
			this.bookingId = data.booking_id,
			this.sessionType = data.session_type,
			this.sessionStartTime = data.appointment_datetime_utc,
			this.sessionEndTime = data.end_datetime_utc,
			this.cancelReason = data.cancel_reason ?? '',
			this.otherReason = data.otherReason ?? ''
	}

	cancelSession() {
		this.isLoading = true;

		const finalReason = this.cancelReason === 'Other' ? this.otherReason : this.cancelReason
		const payload = {
			booking_id: this.bookingId,
			cancel_reason: finalReason
		};
		this.subscription.add(
			this._mentorService.deleteBookingForm(this.bookingId ,finalReason).pipe(
				tap(response => {
					if (response.Success) {
						this._toastr.success(`Your session with ${this.mentorName} has been cancelled successfully.`);
						this.dialogRef.close(true);
					} else {
						this.dialogRef.close(false);
						this._toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.isLoading = false;
				}),
				catchError(() => {
					this._toastr.error('Something went wrong while cancelling this session');
					this.dialogRef.close(false);
					return of(null);
				})
			).subscribe());
	}

	close() {
		this.dialogRef.close(false);
	}

	backToCancelPage() {
		this.dialogRef.close();
		this.dialogRef.afterClosed().subscribe(() => {
			this.dialog.open(MentorSessionCancelDialogComponent, {
				data: {
					booking_id: this.bookingId,
					mentor_name: this.mentorName,
					session_type: this.sessionType,
					appointment_datetime_utc: this.sessionStartTime,
					end_datetime_utc: this.sessionEndTime,
					formState: {
						cancel_reason: this.cancelReason,
						otherReason: this.otherReason
					},
				}
			});
		});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}